import React from 'react'
import styles from './PlusNumber.module.scss'
import cl from 'classnames'
import { PlusNumberProps } from './PlusNumber.types'

const PlusNumberComponent = (props: PlusNumberProps) => {
  const {
    num,
    className,
    ...rest
  } = props

  return (
    <span className={cl(styles.additionalCount, className)} {...rest}>
      +{num}
    </span>
  )
}

const PlusNumber = PlusNumberComponent
export { PlusNumber }
